export enum RenderCellTypes {
  BUTTON = "BUTTON",
  /** Underlined text button + copy icon (e.g. lead details with nurturing on text click). */
  BUTTON_WITH_COPY = "BUTTON_WITH_COPY",
  BUTTON_WITH_ICON = "BUTTON_WITH_ICON",
  TEXT = "TEXT",
  TEXT_WITH_COPY = "TEXT_WITH_COPY",
  NUMBER = "NUMBER",
  STATUS = "STATUS",
  INFO_TOOLTIP = "INFO_TOOLTIP",
  POPOVER_INFO = "POPOVER_INFO",
  DATE = "DATE",
  TIME = "TIME",
  DATETIME = "DATETIME",
  DATETIME_UTC = "DATETIME_UTC",
  NUMBER_PERCENT = "NUMBER_PERCENT",
  COUNT_WITH_ICON = "COUNT_WITH_ICON",
  BUTTON_WITH_ACTION_ICONS = "BUTTON_WITH_ACTION_ICONS",
  ACTION_BUTTONS = "ACTION_BUTTONS",
  OFFER_ACTIONS = "OFFER_ACTIONS",
  RUN_LOG_STATUS_WITH_RETRY = "RUN_LOG_STATUS_WITH_RETRY",
  OFFER_HEADLINE = "OFFER_HEADLINE",
  OFFER_ACTIVE_TOGGLE = "OFFER_ACTIVE_TOGGLE",
  EMAIL_TEMPLATE_ACTIONS = "EMAIL_TEMPLATE_ACTIONS",
  EMAIL_TEMPLATE_STATUS_DROPDOWN = "EMAIL_TEMPLATE_STATUS_DROPDOWN",
  RATE = "RATE",
  IMAGE = "IMAGE",
  CHIP_ARRAY = "CHIP_ARRAY",
  METADATA_MODAL = "METADATA_MODAL",
  RESOURCE_NAME = "RESOURCE_NAME",
}
